// extracted by mini-css-extract-plugin
module.exports = {"article-bg":"SeoArticle_article-bg__6BXL4","article-mb":"SeoArticle_article-mb__XBNFY"};